import { MsalGuard } from '@azure/msal-angular';

import { VexRoutes } from '@vex/interfaces/vex-route.interface';

import { autorizacaoAwaitGuard } from '@shared/infra/autorizacao/autorizacao-await.guard';
import { DASHBOARD_ROUTES } from './features/dashboards/dashboards.routes';
import { ADMIN_CONFIGURACAO_ROUTES } from './features/menu/admin-configuracao.router';
import { ADMIN_CONTROLE_ACESSO_ROUTES } from './features/menu/admin-controle-acesso.router';
import { COMISSOES_ROUTES } from './features/menu/comissoes.router';
import { ADMIN_MINHA_CONTA_ROUTES } from './features/minha-conta/admin-minha-conta.router';
import { LayoutComponent } from './layouts/layout/layout.component';

export const appRoutes: VexRoutes = [
  {
    path: 'error/error-401',
    loadComponent: () =>
      import('./shared/errors/error-401/error-401.component').then(
        (c) => c.Error401Component
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard, autorizacaoAwaitGuard()],
    children: [
      { path: '', children: DASHBOARD_ROUTES },
      {
        path: 'admin',
        children: [
          {
            path: 'minha-conta',
            children: ADMIN_MINHA_CONTA_ROUTES,
          },
          {
            path: 'config',
            children: ADMIN_CONFIGURACAO_ROUTES,
          },
          
          {
            path: 'acesso',
            children: ADMIN_CONTROLE_ACESSO_ROUTES,
          },
        ],
      },
      {
        path: 'operacao',
        children: [
          {
            path: '',
            children: COMISSOES_ROUTES,
          },
        ],
      },
      {
        path: 'politica',
        children: [
          {
            path: '',
            children: COMISSOES_ROUTES,
          },
        ],
      },
      {
        path: 'error',
        children: [
          {
            path: 'error-403',
            loadComponent: () =>
              import('./shared/errors/error-403/error-403.component').then(
                (c) => c.Error403Component
              ),
          },
          {
            path: 'error-404',
            loadComponent: () =>
              import('./shared/errors/error-404/error-404.component').then(
                (c) => c.Error404Component
              ),
          },
          {
            path: 'error-500',
            loadComponent: () =>
              import('./shared/errors/error-500/error-500.component').then(
                (c) => c.Error500Component
              ),
          },
        ],
      },
    ],
  },
];
